import i18n from '@/plugins/i18n'

export enum QuestionnaireType {
  WELLNESS = 'wellness',
  RPE = 'rpe',
  SCOUTING = 'scouting',
  SCOUTING_PERIOD = 'scouting_period',
  CUSTOM = 'custom'
}

export const QuestionnaireTypes = {
  [QuestionnaireType.WELLNESS]: {
    get text() {
      return i18n.t('questionnaire_type.wellness')
    }
  },
  [QuestionnaireType.RPE]: {
    get text() {
      return i18n.t('questionnaire_type.rpe')
    }
  },
  [QuestionnaireType.SCOUTING]: {
    get text() {
      return i18n.t('questionnaire_type.scouting')
    }
  },
  [QuestionnaireType.SCOUTING_PERIOD]: {
    get text() {
      return i18n.t('questionnaire_type.scouting_period')
    }
  },
  [QuestionnaireType.CUSTOM]: {
    get text() {
      return i18n.t('questionnaire_type.custom')
    }
  }
}

/** Coach Permission interface */
export interface ICoachPermission {
  team_id: number;
  coach_id: number;
  can_view: boolean;
  can_edit: boolean;
}

/** Default Questionnaire */
export interface IQuestionnaire {
  id: number;
  organisation_id: number | null;
  parent_questionnaire_id: number | null;
  name: string;
  description: string;
  type: string;
  settings: any;
  is_on_demand: boolean;
  is_active: boolean;
  trigger_criteria: any | null;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
  organisation?: any;
  questions?: IQuestion[];
  coach_permissions?: ICoachPermission[];
}

/** Question interface */
export interface IQuestion {
  id: number;
  questionnaire_id: number;
  text: string;
  type: string;
  values: any[];
  order: number;
  settings: any;
  is_active: boolean;
}
